<template>
  <img src="../assets/logo.svg" width="120" height="50" />
</template>
<script>
export default {
  name: "Logo"
};
</script>
